// ABOUTME: Theme scope for the embedded configurator: paints its page background with the tenant's theme.bgColor.
// ABOUTME: The configurator reads background.secondary, which the PIM theme does not define on its own.

import { Theme, ThemeProvider } from '@ds/coolshop';
import { usePageBgColor } from '@src/_new/modules/settings/hooks/usePageBgColor';
import { ReactNode, useCallback } from 'react';

/**
 * Hands the configurator the page background configured in settings (`theme.bgColor`), so it blends
 * with the PIM pages around it. Scoped to the configurator: the rest of the app keeps its theme.
 */
export const ConfiguratorThemeProvider = ({ children }: { children: ReactNode }) => {
    const pageBgColor = usePageBgColor();

    const theme = useCallback(
        (outerTheme: Theme): Theme => ({
            ...outerTheme,
            palette: {
                ...outerTheme.palette,
                background: { ...outerTheme.palette.background, secondary: pageBgColor },
            },
        }),
        [pageBgColor],
    );

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
